// extracted by mini-css-extract-plugin
module.exports = {"createNewBoar":"createBoardButton_createNewBoar__3TrFo","CreateBoardButton":"createBoardButton_CreateBoardButton__3cx0L"};